import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import { useParams } from "react-router-dom";
import { documentacionPorSolicitud } from "../../Services/Rest";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

function RepositorioEvaluador(props) {
  let { id } = useParams();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerArchivosRepositorio?InstitucionId=" +
        id,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Repositorio de información
                </h6>
              </div>
              <div class="card-body">
                <div className="form-group row">
                  <div className="col-sm-12"></div>
                </div>

                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Archivo</th>
                        <th>Ciclo</th>
                        <th>Año</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.id}</td>
                            <td>{item.nombre}</td>
                            <td>
                              <button
                                className="btn btn-success"
                                onClick={() =>
                                  descargarDocumento(item.ubicacion)
                                }
                              >
                                Descargar
                              </button>
                            </td>

                            <td> {item.ciclo}</td>

                            <td>{item.ano}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default RepositorioEvaluador;
